/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-08-08 17:54:45
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\validate.ts
 */
/**
 * 判断是否是外链
 * @param {string} path
 * @returns {Boolean}
 * @author LiQingSong
 */
export const isExternal = (path: string): boolean => {
  return /^(https?:|mailto:|tel:)/.test(path);
}

//校验邮箱
export const isEmail = (email: string): boolean => {
  return /^([a-zA-Z0-9-]+[a-zA-Z0-9\.\_]*)+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(email)
}

//校验手机号
export const isPhone = (phone: string): boolean => {
  return /^0?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/.test(phone)
}

//校验密码6-20位大小写英文与数据特殊符号
export const isPassword = (password: string): boolean => {
  return /(?=.*[0-9])(?=.*[a-zA-Z]).{6,20}/.test(password)
}

//校验身份证号码
export const isIdcard = (code: string): boolean => {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/.test(code)
}

//校验固定电话号码
export const isTel = (tel: string): boolean => {
  return /0\d{2,3}-\d{7,8}/.test(tel)
}

//校验IOSS
export const isIoss = (val: string): boolean => {
  return /^[I][M][0-9]{10,10}$/.test(val)
}

//校验邮编
export const isPostal = (val: string): boolean => {
  return /^[0-9A-Za-z-_()]{1,8}$/.test(val)
}

//校验统一社会信用代码
export const isUscode = (val: string): boolean => {
  return /^[0-9A-Za-z-_]{18,18}$/.test(val)
}

//判断润年
export const isRunNian = (val: string): boolean => {
  const year = Number(val)
  if(year%100!=0&&year%4==0||year%400==0){
    return true
  }else{
    return false
  }
}
